<div class="page-layout carded fullwidth">
  <div class="center">
    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h1">
        {{ 'DEADLINES.TITLE' | translate }}
      </span>

      <div class="page-buttons" fxHide.xs>
        <mat-slide-toggle
          labelPosition="before"
          [matTooltip]="'DEADLINES.AUTO_RELOAD_TIME' | translate"
          (change)="autoRefresh($event)"
          [checked]="false"
        >
          {{ 'DEADLINES.AUTO_RELOAD' | translate }}
        </mat-slide-toggle>

        <button
          mat-stroked-button
          [matTooltip]="'DEADLINES.RELOAD' | translate"
          (click)="refresh()"
          [disabled]="isLoading"
        >
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>

        <button
          *ngIf="isFiltered"
          mat-stroked-button
          [matTooltip]="'DEADLINES.FILTERS.CLEAR' | translate"
          [disabled]="isLoading"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>
      </div>

      <div class="page-buttons" [fxShow]="false" fxShow.xs>
        <button mat-stroked-button [matMenuTriggerFor]="menuDeadlines">
          <mat-icon class="accent-500-fg">keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuDeadlines>
          <button mat-menu-item fxLayout="row" fxLayoutAlign="start center" (click)="refresh()">
            <i class="angularjs-fuse-icon icon-reload small mr-4"></i>
            <span>
              {{ 'DEADLINES.RELOAD' | translate }}
            </span>
          </button>

          <button
            mat-menu-item
            fxLayout="row"
            fxLayoutAlign="start center"
            (click)="clearFilters()"
            [disabled]="isLoading"
          >
            <i class="angularjs-fuse-icon icon-filter-remove small mr-4"></i>
            <span>
              {{ 'DEADLINES.FILTERS.CLEAR' | translate }}
            </span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="deadlines">
      <div class="row">
        <div class="deadlines__card">
          <deadlines-filter></deadlines-filter>
        </div>
      </div>

      <div class="deadlines__card">
        <div class="deadlines__card__chart-wrapper">
          <div class="deadlines__card__chart-wrapper__header">
            <h3>{{ 'DEADLINES.CARDS.RESPONSE.TITLE' | translate }}</h3>
          </div>

          <div class="deadlines__card__chart-wrapper__status">
            <data-card
              [title]="'DEADLINES.CARDS.WITHOUT_DEADLINE' | translate"
              color="#168acf"
              [data]="data && data.currentPeriod && data.currentPeriod.withoutDeadlineCount"
              [isLoading]="isLoading"
            >
              <see-more-footer
                [isLoading]="isLoading"
                (clickSeeMore)="goToMaintenancesPage({ solutionPeriod: 'notApplied' })"
              ></see-more-footer>
            </data-card>

            <data-card
              [title]="'DEADLINES.CARDS.MAINTENANCES_ON' | translate"
              color="#24b787"
              [data]="data && data.currentPeriod && data.currentPeriod.fistVisitOnTimeCount"
              [isLoading]="isLoading"
            >
              <see-more-footer
                [isLoading]="isLoading"
                (clickSeeMore)="goToMaintenancesPage({ responsePeriod: 'on' })"
              ></see-more-footer>
            </data-card>

            <data-card
              [title]="'DEADLINES.CARDS.MAINTENANCES_OUT' | translate"
              color="#fc3868"
              [data]="data && data.currentPeriod && data.currentPeriod.fistVisitOutTimeCount"
              [isLoading]="isLoading"
            >
              <see-more-footer
                [isLoading]="isLoading"
                (clickSeeMore)="goToMaintenancesPage({ responsePeriod: 'out' })"
              ></see-more-footer>
            </data-card>

            <data-card
              [title]="'DEADLINES.CARDS.RESPONSE.AVERAGE' | translate"
              color="#168acf"
              [data]="
                data && data.currentPeriod && data.currentPeriod.averageResponseTimeInDays | formatDuration: 'days'
              "
              [isLoading]="isLoading"
            >
              <previous-period-footer
                [isLoading]="isLoading"
                [data]="
                  data && data.footerPeriod && data.footerPeriod.averageResponseTimeInDays | formatDuration: 'days'
                "
                [percentage]="
                  data && data.currentPeriod && data.currentPeriod.averageResponseTimeInDays
                    | percentageDecreaseOrIncrease
                      : data && data.footerPeriod && data.footerPeriod.averageResponseTimeInDays
                "
                [current]="data && data.footerPeriod && data.footerPeriod.averageResponseTimeInDays"
                [previous]="data && data.currentPeriod && data.currentPeriod.averageResponseTimeInDays"
              ></previous-period-footer>
            </data-card>

            <data-card
              [title]="'DEADLINES.CARDS.RESPONSE.AVG_ON' | translate"
              color="#1a61f7"
              [isChart]="true"
              [isLoading]="isLoading"
            >
              <gauge-chart
                *ngIf="!isLoading"
                slot="chart"
                [value]="data && data.currentPeriod && data.currentPeriod.responseOnTimePercentage"
              ></gauge-chart>

              <previous-period-footer
                [isLoading]="isLoading"
                [data]="data && data.footerPeriod && (data.footerPeriod.responseOnTimePercentage * 100).toFixed() + '%'"
                [percentage]="
                  data && data.footerPeriod && data.footerPeriod.responseOnTimePercentage
                    | percentageDecreaseOrIncrease
                      : data && data.currentPeriod && data.currentPeriod.responseOnTimePercentage
                "
                [previous]="data && data.footerPeriod && data.footerPeriod.responseOnTimePercentage"
                [current]="data && data.currentPeriod && data.currentPeriod.responseOnTimePercentage"
              ></previous-period-footer>
            </data-card>
          </div>
        </div>

        <div class="deadlines__card__chart-wrapper print-padding">
          <div class="deadlines__card__chart-wrapper__header">
            <h3>{{ 'DEADLINES.CARDS.SOLUTION.TITLE' | translate }}</h3>
          </div>

          <div class="deadlines__card__chart-wrapper__status">
            <data-card
              [title]="'DEADLINES.CARDS.WITHOUT_DEADLINE' | translate"
              color="#168acf"
              [data]="data && data.currentPeriod && data.currentPeriod.withoutDeadlineCount"
              [isLoading]="isLoading"
            >
              <see-more-footer
                [isLoading]="isLoading"
                (clickSeeMore)="goToMaintenancesPage({ solutionPeriod: 'notApplied' })"
              ></see-more-footer>
            </data-card>

            <data-card
              [title]="'DEADLINES.CARDS.MAINTENANCES_ON' | translate"
              color="#24b787"
              [data]="data && data.currentPeriod && data.currentPeriod.closedOnTimeCount"
              [isLoading]="isLoading"
            >
              <see-more-footer
                [isLoading]="isLoading"
                (clickSeeMore)="goToMaintenancesPage({ solutionPeriod: 'on' })"
              ></see-more-footer>
            </data-card>

            <data-card
              [title]="'DEADLINES.CARDS.MAINTENANCES_OUT' | translate"
              color="#fc3868"
              [data]="data && data.currentPeriod && data.currentPeriod.closedOutTimeCount"
              [isLoading]="isLoading"
            >
              <see-more-footer
                [isLoading]="isLoading"
                (clickSeeMore)="goToMaintenancesPage({ solutionPeriod: 'out' })"
              ></see-more-footer>
            </data-card>

            <data-card
              [title]="'DEADLINES.CARDS.SOLUTION.AVERAGE' | translate"
              color="#168acf"
              [data]="data && data.currentPeriod && data.currentPeriod.averageCloseTimeInDays | formatDuration: 'days'"
              [isLoading]="isLoading"
            >
              <previous-period-footer
                [isLoading]="isLoading"
                [data]="data && data.footerPeriod && data.footerPeriod.averageCloseTimeInDays | formatDuration: 'days'"
                [percentage]="
                  data && data.currentPeriod && data.currentPeriod.averageCloseTimeInDays
                    | percentageDecreaseOrIncrease
                      : data && data.footerPeriod && data.footerPeriod.averageCloseTimeInDays
                "
                [current]="data && data.footerPeriod && data.footerPeriod.averageCloseTimeInDays"
                [previous]="data && data.currentPeriod && data.currentPeriod.averageCloseTimeInDays"
              ></previous-period-footer>
            </data-card>

            <data-card
              [title]="'DEADLINES.CARDS.SOLUTION.AVG_ON' | translate"
              color="#1a61f7"
              [isChart]="true"
              [isLoading]="isLoading"
            >
              <gauge-chart
                *ngIf="!isLoading"
                slot="chart"
                [value]="data && data.currentPeriod && data.currentPeriod.closedOnTimePercentage"
              ></gauge-chart>

              <previous-period-footer
                [isLoading]="isLoading"
                [data]="data && data.footerPeriod && (data.footerPeriod.closedOnTimePercentage * 100).toFixed() + '%'"
                [percentage]="
                  data && data.footerPeriod && data.footerPeriod.closedOnTimePercentage
                    | percentageDecreaseOrIncrease
                      : data && data.currentPeriod && data.currentPeriod.closedOnTimePercentage
                "
                [previous]="data && data.footerPeriod && data.footerPeriod.closedOnTimePercentage"
                [current]="data && data.currentPeriod && data.currentPeriod.closedOnTimePercentage"
              ></previous-period-footer>
            </data-card>
          </div>
        </div>
      </div>

      <div class="deadlines__card">
        <div class="deadlines__card__chart-wrapper">
          <div
            fxLayout="row"
            fxLayoutGap="40px 40px"
            fxLayoutAlign="space-between start"
            class="deadlines__card__chart-wrapper__header"
          >
            <div>
              <h3>{{ 'DEADLINES.CARDS.TIMELINE.RESPONSE_TITLE' | translate }}</h3>
              <h4>{{ 'DEADLINES.CARDS.TIMELINE.RESPONSE_DESCRIPTION' | translate }}</h4>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center center">
              <mat-icon
                class="material-icons-outlined"
                [matTooltip]="'DEADLINES.CARDS.FILTERS.INFO' | translate"
                matTooltipPosition="left"
                [matTooltipShowDelay]="500"
              >
                info
              </mat-icon>

              <mat-form-field appearance="outline">
                <mat-select
                  [(ngModel)]="lastOpenedAtResponse"
                  (ngModelChange)="
                    lastOpenedAtChartChanges.next({
                      type: 'response',
                      value: lastOpenedAtResponse
                    })
                  "
                >
                  <mat-option value="lastSevenDays">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_SEVEN_DAYS' | translate }}
                  </mat-option>
                  <mat-option value="lastThirtyDays">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_THIRTY_DAYS' | translate }}
                  </mat-option>
                  <mat-option value="lastNinetyDays">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_NINETY_DAYS' | translate }}
                  </mat-option>
                  <mat-option value="lastSixMonths">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_SIX_MONTHS' | translate }}
                  </mat-option>
                  <mat-option value="lastTwelveMonths">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_TWELVE_MONTHS' | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <stacked-vertical-bar [data]="responseTimeline" [isLoading]="isLoading || isLoadingOnlyResponseChart">
            <span
              slot="legend"
              fxLayout="row"
              fxLayoutAlign="start start"
              fxLayoutGap="60px"
              class="deadlines__card__chart-wrapper__legend"
            >
              <p>{{ 'DEADLINES.CARDS.FILTERS.LEGENDS.ON' | translate }}</p>
              <p>{{ 'DEADLINES.CARDS.FILTERS.LEGENDS.OUT' | translate }}</p>
            </span>
          </stacked-vertical-bar>
        </div>
      </div>

      <div class="deadlines__card">
        <div class="deadlines__card__chart-wrapper">
          <div
            fxLayout="row"
            fxLayoutGap="40px 40px"
            fxLayoutAlign="space-between start"
            class="deadlines__card__chart-wrapper__header"
          >
            <div>
              <h3>{{ 'DEADLINES.CARDS.TIMELINE.SOLUTION_TITLE' | translate }}</h3>
              <h4>{{ 'DEADLINES.CARDS.TIMELINE.SOLUTION_DESCRIPTION' | translate }}</h4>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="center center">
              <mat-icon
                class="material-icons-outlined"
                [matTooltip]="'DEADLINES.CARDS.FILTERS.INFO' | translate"
                matTooltipPosition="left"
                [matTooltipShowDelay]="500"
              >
                info
              </mat-icon>

              <mat-form-field appearance="outline">
                <mat-select
                  [(ngModel)]="lastOpenedAtSolution"
                  (ngModelChange)="
                    lastOpenedAtChartChanges.next({
                      type: 'solution',
                      value: lastOpenedAtSolution
                    })
                  "
                >
                  <mat-option value="lastSevenDays">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_SEVEN_DAYS' | translate }}
                  </mat-option>
                  <mat-option value="lastThirtyDays">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_THIRTY_DAYS' | translate }}
                  </mat-option>
                  <mat-option value="lastNinetyDays">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_NINETY_DAYS' | translate }}
                  </mat-option>
                  <mat-option value="lastSixMonths">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_SIX_MONTHS' | translate }}
                  </mat-option>
                  <mat-option value="lastTwelveMonths">
                    {{ 'DEADLINES.CARDS.FILTERS.LAST_TWELVE_MONTHS' | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <stacked-vertical-bar [data]="solutionTimeline" [isLoading]="isLoading || isLoadingOnlySolutionChart">
            <span
              slot="legend"
              fxLayout="row"
              fxLayoutAlign="start start"
              fxLayoutGap="60px"
              class="deadlines__card__chart-wrapper__legend"
            >
              <p>{{ 'DEADLINES.CARDS.FILTERS.LEGENDS.ON' | translate }}</p>
              <p>{{ 'DEADLINES.CARDS.FILTERS.LEGENDS.OUT' | translate }}</p>
            </span>
          </stacked-vertical-bar>
        </div>
      </div>
    </div>
  </div>
</div>
